export const uk = {
    'add-button': 'Добавить',
    'exclude-phrases': 'Исключить фразы с нулевыми показами',
    placeholder: 'Добавить ключевые фразы. Введите фразы через запятую или с помощью оператора ( | )'
};
